import { createSlice } from "@reduxjs/toolkit";
import { cardStateName, cardInitialState } from "./constants";

const cardSlice = createSlice({
  name: cardStateName,
  initialState: cardInitialState,
  reducers: {
    setCard(state, action) {
      state.card = action.payload;
    },
  },
});

export const { name, reducer, actions } = cardSlice;
